export const companiesCompanyIdDevelopersCurrentPrefCenterUrl =
  "/companies/:company_id/developers/current/pref_center_url";
